import {
  Drawer,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  IconButton,
} from "@mui/material";
import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { displayDate } from "./action";
import CloseIcon from "@mui/icons-material/Close";

const minifyText = (str, length = 30) => {
  if (str.length > length) {
    return str.substring(0, length) + "...";
  } else {
    return str;
  }
};

const HistoryCard = ({ data, click }) => {
  const mode = data?.settings?.mode;
  let modeTitle = "";
  if (mode === "marking" || mode === "mark") {
    modeTitle = "評改作文";
  } else if (mode === "recommend") {
    modeTitle = "作文建議";
  } else if (mode === "generate") {
    modeTitle = "生成範文";
  } else if (mode === "rewrite") {
    modeTitle = "作文改寫";
  }
  return (
    <Card sx={{ height: "100%", cursor: "pointer" }} onClick={click}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {displayDate(data._createdAt)}
        </Typography>
        <Typography variant="body1" component="div">
          {data?.topic ? minifyText(data?.topic) : minifyText(data?.input)}
        </Typography>
        <Typography variant="subtitle2">{modeTitle}</Typography>
        <Typography variant="subtitle2">{data.marking_scheme}</Typography>
      </CardContent>
    </Card>
  );
};

const HistoryDrawer = ({ historyData, state, setDrawer, resultFn }) => {
  const theme = useTheme();
  const [filterMode, setFilterMode] = React.useState("all");

  const handleFilterChange = (event) => {
    setFilterMode(event.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  // Filter data based on selected mode
  const filteredData = filterMode
    ? historyData
        ?.filter((data) => {
          const mode = data?.settings?.mode;
          switch (filterMode) {
            case "marking":
            case "mark":
              return mode === "marking" || mode === "mark";
            case "recommend":
              return mode === "recommend";
            case "generate":
              return mode === "generate";
            case "rewrite":
              return mode === "rewrite";
            default:
              return mode !== "markingScheme";
          }
        })
        .slice(0, 90)
    : historyData;

  // Pagination state
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 9;

  if (!historyData) {
    return null;
  }

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Calculate paginated data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Check if there are more pages
  const hasNextPage = startIndex + itemsPerPage < filteredData.length;
  const hasPreviousPage = currentPage > 1;

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawer(open);
  };

  const clickHandler = (data) => {
    resultFn(data);
  };

  return (
    <Drawer anchor="bottom" open={state} onClose={toggleDrawer(false)}>
      <Grid
        container
        spacing={2}
        sx={{
          p: 3,
          background: theme.palette.primary.dark,
          color: theme.palette.info.contrastText,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <Typography variant="h5" sx={{ my: 3, mx: 5 }}>
            mAI Mind 紀錄
          </Typography>
          <IconButton
            aria-label="close"
            onClick={toggleDrawer(false)}
            sx={{
              color: (theme) => theme.palette.grey[50],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        {/* <Grid item xs={12} sx={{ display: { md: "none" } }}>
          <Button
            variant="contained"
            size="large"
            onClick={toggleDrawer(false)}
            sx={{
              width: "100%",
              background: theme.palette.common.white,
              color: theme.palette.common.white.contrastText,
            }}
          >
            ❌
          </Button>
        </Grid> */}
        {/* {historyData &&
          historyData.length > 0 &&
          historyData.map((data, idx) => {
            return (
              <Grid item xs={12} md={4} key={`history-${idx}`}>
                <HistoryCard data={data} click={() => clickHandler(data)} />
              </Grid>
            );
          })} */}
        {paginatedData &&
          paginatedData.map((data, idx) => {
            return (
              <Grid item xs={12} md={4} key={`history-${idx}`}>
                <HistoryCard data={data} click={() => clickHandler(data)} />
              </Grid>
            );
          })}
        <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
          <Stack
            direction="row"
            alignItems={"center"}
            justifyContent="center"
            sx={{ mt: 2 }}
          >
            <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
              <FormControl width="100%" sx={{ p: 1 }} size="large">
                <InputLabel sx={{ color: theme.palette.info.contrastText }}>
                  選擇模式
                </InputLabel>
                <Select
                  value={filterMode}
                  onChange={handleFilterChange}
                  label="選擇模式"
                  sx={{
                    color: theme.palette.info.contrastText,
                    backgroundColor: theme.palette.primary.light,
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.info.contrastText,
                    },
                  }}
                >
                  <MenuItem value="all">全部</MenuItem>
                  <MenuItem value="recommend">作文建議</MenuItem>
                  <MenuItem value="generate">生成範文</MenuItem>
                  <MenuItem value="rewrite">作文改寫</MenuItem>
                  <MenuItem value="marking">評改作文</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              sx={{ width: "100%" }}
              spacing={2}
              mt={2}
            >
              <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ color: theme.palette.info.contrastText }}
                >
                  第 {currentPage} 頁 / 共 {totalPages} 頁
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  disabled={hasPreviousPage === false}
                  sx={{
                    background: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                >
                  上一頁
                </Button>
                <div style={{ width: "10px" }} />
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  disabled={hasNextPage === false}
                  sx={{
                    background: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                >
                  下一頁
                </Button>
              </Grid>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ display: { md: "none" } }}>
          <Button
            variant="contained"
            size="large"
            onClick={toggleDrawer(false)}
            sx={{
              width: "100%",
              background: theme.palette.common.white,
              color: theme.palette.common.white.contrastText,
            }}
          >
            ❌
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default HistoryDrawer;
